import { useState, useEffect } from 'react';
export const useCookie = (cookieManager, cookieName) => {
    const [cookieValue, setCookieValue] = useState(cookieManager.getCookie(cookieName));
    const handleCookieChange = () => {
        const newValue = cookieManager.getCookie(cookieName);
        setCookieValue(newValue);
    };
    useEffect(() => {
        cookieManager.cookieChange.addChangeListener(handleCookieChange);
        return () => {
            cookieManager.cookieChange.removeChangeListener(handleCookieChange);
        };
    }, [cookieManager, cookieName]);
    return cookieValue;
};
//# sourceMappingURL=useCookie.js.map